import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { StatesSkeleton } from 'flyt';

const CenterWrapper = styled(Box)({
	position: 'fixed',
	top: 0,
	left: 0,
	bottom: 0,
	right: 0,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
	gap: '16px',
});

export function Loading({ text = null }) {
	return (
		<CenterWrapper>
			<CircularProgress size={32} thickness={4} />

			{text && (
				<Box
					component="p"
					sx={{ m: 0, color: 'text.secondary', fontSize: '0.875rem' }}
				>
					{text}
				</Box>
			)}
		</CenterWrapper>
	);
}

export function InlineLoading({ text = null, lines = 3 }) {
	return (
		<div className="flex w-full flex-col gap-3 py-2">
			{text && <p className="m-0 text-sm text-text-muted">{text}</p>}

			<StatesSkeleton lines={lines} />
		</div>
	);
}

export default Loading;
